import React, { forwardRef } from "react";
import { Row } from "reactstrap";
import moment from "moment";
import zithasLogo from "../../../../assets/images/zithasLogo.png";
import sign from "../../../../assets/images/signature.png";

const ContractPreview = forwardRef(
  ({ description, signature, contractId, sign_name, date }, ref) => {
    return (
      <div
        className="contract-preview bg-white p-5 shadow document"
        ref={ref}
        id="zithasInvoicePrint"
        style={{
          fontSize: "12pt",
          lineHeight: "1.6",
          maxWidth: "800px",
          margin: "0 auto",
        }}
      >
        {/* Logo */}
        <div className="pb-4 text-center">
          <img src={zithasLogo} height="80" alt="zithasLogo" />
        </div>

        {/* Contract Content */}
        <div className="mt-5">
          <div
            style={{ textAlign: "justify", fontSize: "12pt" }}
            className="Features"
            dangerouslySetInnerHTML={{
              __html: description || "<p></p>",
            }}
          />
        </div>

        {/* Date */}
        <h5
          className="fw-bold text-decoration-underline mt-5"
          style={{ fontSize: "12pt" }}
        >
          Date :{" "}
          {date
            ? moment(date).format("DD-MM-YYYY")
            : moment().format("DD-MM-YYYY")}
        </h5>

        {/* Signatures */}
        <Row className="mt-5 justify-content-between">
          <div className="col-4 text-center">
            {sign_name?.length !== 0 ? (
              <img src={sign} height="60" className="mb-3" alt="Zithas Sign" />
            ) : (
              <div
                className="sign-box"
                style={{ height: "60px", lineHeight: "60px" }}
              >
                Signature
              </div>
            )}
            <h5 style={{ fontSize: "12pt", marginBottom: "2px" }}>
              Julius Gohil
            </h5>
            <div style={{ fontSize: "10pt", marginBottom: "2px" }}>
              Managing Director
            </div>
            <div style={{ fontSize: "10pt" }}>For Zithas Technologies</div>
          </div>

          <div className="col-4 text-center">
            {signature ? (
              <img
                src={signature}
                height="60"
                className="mb-3"
                alt="User Sign"
              />
            ) : (
              <div
                className="sign-box"
                style={{ height: "60px", lineHeight: "60px" }}
              >
                Signature
              </div>
            )}
            <h5 style={{ fontSize: "12pt" }}>{sign_name || "Client Name"}</h5>
          </div>
        </Row>
      </div>
    );
  }
);

// ✅ Add display name
ContractPreview.displayName = "ContractPreview";

export default ContractPreview;
